import React from 'react';
import QuizStore from './../../stores/QuizStore.js';
import QuizActionCreators from './../../actions/QuizActionCreators.js';
import CheckboxQuestion from '../questions/CheckboxQuestion.react';
import cx from '../../utils/cx.js';

class QuizResults extends React.Component {
	static defaultProps = {
	  result_id: null,
	  hide_results: false,
	  type: 'default',
	};

	state = {
	  hide_result: !this.props.hide_results,
	};

	render() {
	  const self = this;
	  let test_result = false;
	  const result_data = QuizStore.getResults();
	  let max_lenght = 0;
	  let tmp_result = null;
	  const type = this.props.type;

	  if (this.props.result_id != null) {
	    test_result = this.props.result_id;
	  }

	  if (test_result == false) {
	    result_data.forEach((result, index) => {
	      if (result.length > max_lenght) {
	        max_lenght = result.length;
	        tmp_result = index;
	      }
	    });

	    test_result = tmp_result;
	  }

	  const quiz_results = this.props.quiz.results;
	  const quiz_id = this.props.quiz._id;
	  let share_url = this.props.quiz.share_url;
	  let quiz_result_data = [];
	  let logged_id = false;
	  let share_teksts = 'Vēlies zināt, kuram mīlnieku tipam tu piederi? Aizpildi Durex testu „Guļamistabas rotaļas: Kāda tipa mīlnieks tu esi?” tagad!';
	  const dr_title = 'Kāds mīlnieks esi tu? Aizpildi testu un noskaidro jau tagad!';
	  const dr_text = 'Vēlies zināt, kuram mīlnieku tipam tu piederi? Aizpildi Durex testu „Guļamistabas rotaļas: Kāda tipa mīlnieks tu esi?” tagad!';

	  if (this.props.quiz.me != null && typeof this.props.quiz.me !== 'undefined') {
	    logged_id = true;
	  }

	  if (typeof quiz_results !== 'undefined') {
	    for (const index in quiz_results) {
	      if (quiz_results[index].result_id == test_result) {
	        quiz_result_data = quiz_results[index];
	      }
	    }
	  }

	  if (test_result != null) {
	    share_url = `${share_url}/${test_result}`;
	    share_teksts = quiz_result_data.share_txt;
	  }

	  const description = quiz_result_data.description;
	  const member_result_description = quiz_result_data.member_result_description;

	  const resultByType = function () {
	    if (type == 'default') {
	      return (
  <div className="quiz quiz--hasFooter">
    <div className="quiz-results">
      <div className="quiz-results-title">
        <div className={`quiz-results-title-icon quiz-results-title-icon--${test_result}`} />
        {quiz_result_data.title}
      </div>
      <div className="quiz-results-description" dangerouslySetInnerHTML={{ __html: description }} />
    </div>

    <div
      className="questionBlock-meter tooltip"
      data-tooltip={`${op.messages.question}: ${self.props.question_count}/${self.props.question_count}`}
    >
      <div style={{ width: '100%' }} className="questionBlock-meter-inner" />
    </div>

    <div className="quiz-footer">
      <div className="quiz-footer-share">
        <div className="ttu">{op.messages.share_txt}</div>
        <a
          className="quiz-footer-share-fb"
          target="_blank"
          href={`http://www.facebook.com/sharer.php?u=${share_url}`}
          data-popup="true"
        />
        <a
          className="quiz-footer-share-twitter"
          target="_blank"
          href={`http://twitter.com/share?url=${share_url}&text=${share_teksts}`}
          data-popup="true"
        />
        <a
          className="quiz-footer-share-dr"
          target="_blank"
          href={`http://www.draugiem.lv/say/ext/add.php?title=${encodeURIComponent(dr_title)}&text=${encodeURIComponent(dr_text)}&link=${share_url}&titlePrefix=otrapuse.lv`}
          data-popup="true"
        />
      </div>
      <div className="quiz-repeat dib prl" onClick={e => self._handleRepeatClick(e)}>
        <div className="quiz-repeatIcon" />
        {op.messages.repeat}
      </div>
      <div className={cx(['quiz-hide-result dib', ['hide', !logged_id]])} onClick={e => self._handleHideClick(e)}>
        <div className={cx(['quiz-checkBox', ['quiz-checkBox--active', !self.state.hide_result]])} />
        {op.messages.hide_result}
      </div>
    </div>
  </div>
	      );
	    }
	    const quizResultsTitle = function () {
	      if (test_result != null) {
	        return (
  <div className="quiz-results-title">
    <div className={`quiz-results-title-icon quiz-results-title-icon--${test_result}`} />
    <div>Mans mīlnieka tips ir: <br />{quiz_result_data.title}</div>
  </div>
	        );
	      }
	      return ('');
	    };

	    const quizResultsDescription = function () {
	      if (test_result != null) {
	        return (
  <div className="quiz-results-description" dangerouslySetInnerHTML={{ __html: member_result_description }} />
	        );
	      }
	      if (type == 'member_hidden') {
	        return (
  <div className="quiz-results-description">
									Kāds ir mans mīlnieka tips? Zinu, bet neteikšu! Uzraksti man vēstuli, varbūt atklāšu :)<br /><br />
									Noskaidro arī tu savu mīlnieka tipu! Aizpildi testu.
  </div>
	        );
	      }
	      return (
  <div className="quiz-results-description">
									Kāds ir mans mīlnieka tips? To es vēl nezinu, jo vēl nepaspēju aizpildīt testu… bet tu vari mani apsteigt un uzzināt savu mīlnieka tipu jau tagad!<br /><br />
									Aizpildi testu.
  </div>
	      );
	    };

	    const quizResultsContent = function () {
	      if (test_result != null) {
	        return (
  <div className="quiz-results quiz-results--member">
    {quizResultsTitle()}
    {quizResultsDescription()}
    <div className="quiz-start-info">
      <div className="tac">
        <div className="quiz-start-button" onClick={e => self._handleClick(e)}>
          {op.messages.start}
        </div>
      </div>
    </div>
  </div>
	        );
	      }
	      return (
  <div className="quiz-results quiz-results--member quiz-results--memberStart quiz-start">
    <div className="quiz-start-logo--durex" />

    {quizResultsTitle()}
    <div className="quiz-start-info">
      {quizResultsDescription()}
      <div className="quiz-start-title">{self.props.quiz.title}</div>
      <div className="quiz-start-sub_title">{self.props.quiz.sub_title}</div>
      <div className="tac">
        <div className="quiz-start-button" onClick={e => self._handleClick(e)}>
          {op.messages.start}
        </div>
      </div>
    </div>
  </div>
	      );
	    };

	    return (
  <div className="quiz quiz--hasFooter">
    {quizResultsContent()}

    <div className="quiz-footer">
      <div className="quiz-footer-share">
        <div className="ttu">{op.messages.share_txt}</div>
        <a
          className="quiz-footer-share-fb"
          target="_blank"
          href={`http://www.facebook.com/sharer.php?u=${share_url}`}
          data-popup="true"
        />
        <a
          className="quiz-footer-share-twitter"
          target="_blank"
          href={`http://twitter.com/share?url=${share_url}&text=${share_teksts}`}
          data-popup="true"
        />
        <a
          className="quiz-footer-share-dr"
          target="_blank"
          href={`http://www.draugiem.lv/say/ext/add.php?title=${encodeURIComponent(dr_title)}&text=${encodeURIComponent(dr_text)}&link=${share_url}&titlePrefix=otrapuse.lv`}
          data-popup="true"
        />
      </div>
    </div>
  </div>
	    );
	  };

	  return (
	    resultByType()
	  );
	}

	_handleClick = (e) => {
	  e.preventDefault();
	  this.props.startClick();
	};

	_handleRepeatClick = (e) => {
	  e.preventDefault();
	  this.props.click();
	};

	_handleHideClick = (e) => {
	  e.preventDefault();
	  const quiz_data = QuizStore.getQuiz();

	  QuizActionCreators.hideResults(quiz_data._id, this.state.hide_result);
	  this.setState({
	    hide_result: !this.state.hide_result,
	  });

	  console.log(`hide result: ${this.state.hide_result}`);
	};
}

module.exports = QuizResults;
